import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Rechte} from '../../model/rechte.model';
import {ApiUrlService} from "./api-url.service";

@Injectable({
  providedIn: 'root' // ✅ Ensures the service is available globally
})
export class PostfachService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrlService = inject(ApiUrlService);

  public postBenutzerkonto(): Observable<Rechte> {
    const apiUrl = `${this.apiUrlService.getApiUrl()}/postfach`;
    return this.http.post<Rechte>(apiUrl, null);
  }
}